import { useEffect, useState } from 'react';
import './Events.css';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import { Event } from './event';
import DayRow from './components/DayRow';

export default function Events() {
	const navigation = useNavigate();
	const [events, setEvents] = useState<Event[]>([]);

	const urlParams = new URLSearchParams(window.location.search);

	const [showHidden, setShowHidden] = useState(!urlParams.has("hidden"));
	const [selectedYear, setSelectedYear] = useState<number>(parseInt(urlParams.get('year') || new Date().getFullYear().toString()));

	async function fetchEvents() {
		const res = await fetch(`${process.env.REACT_APP_API_URL}/event`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		});

		const data = await res.json();

		if (!res.ok) {
			console.error(data.message);
			return;
		}

		setEvents(data.map((event: Event) => {
			event.startDate = new Date(event.startDate);
			event.endDate = new Date(event.endDate);
			return event;
		}));
	}

	useEffect(() => {
		fetchEvents();
	}, []);

	function updateSelectedYear(year: number) {
		setSelectedYear(year);
		// Write the selected year to the URL as a query parameter
		const url = new URL(window.location.href);
		url.searchParams.set('year', year.toString());
		window.history.replaceState({}, '', url.toString());
	}

	function toggleShowHidden() {
		setShowHidden(!showHidden);
		// Write the showHidden state to the URL as a query parameter
		const url = new URL(window.location.href);
		if (showHidden) {
			url.searchParams.set('hidden', '1');
		} else {
			url.searchParams.delete('hidden');
		}
		window.history.replaceState({}, '', url.toString());
	}

	function eventsSplitByDay(events: Event[]) {
		const eventsByDay: { [key: string]: Event[] } = {};
		events.forEach(event => {
			const day = event.startDate.toISOString().split('T')[0];
			if (!eventsByDay[day]) {
				eventsByDay[day] = [];
			}
			eventsByDay[day].push(event);
		});
		return eventsByDay;
	}

	return (
		<div className={"Events container container-lg " + (showHidden ? "" : "hide-hidden")} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
			<div className="controls container container-m" style={{display: "flex", justifyContent: "space-between", position: "sticky", top: 0, backgroundColor: "white", zIndex: 1}}>
				<label>
					Filter by year:
					<input type="number" value={selectedYear} onChange={(e) => updateSelectedYear(parseInt(e.target.value))} placeholder="Filter by year" />
				</label>
				<label>
					<input type="checkbox" checked={showHidden} onChange={toggleShowHidden} />
					Show Hidden
				</label>
				<Button variant="primary" onClick={() => navigation("/newEvent")}>New Event</Button>
			</div>
			<div className="day-rows" style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>
				{Object.entries(eventsSplitByDay(events)).map(([day, events]) => {
					if (new Date(day).getFullYear() !== selectedYear) return null;
					return <DayRow key={day} day={day} events={events} onDelete={fetchEvents} />;
				})}
			</div>
		</div>
	);
}
